//THEME
import defaults from "./custom/defaults.js";
import navbar from "./custom/navbar.js";
import footer from "./custom/footer.js";
import photo_gallery from "./custom/photo-gallery.js";
import logo_slider from "./custom/logo-slider.js";
